/* unplugin-vue-components disabled */import { ElForm as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElFormItem as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { ElInput as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { ElButton as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "flex"
};
import { useGetVerCode } from '@ultra/share/hooks/useGetVercode';
import { apiSendSms, apiSetPwd } from '@/api/user';
import { Md5 } from 'ts-md5/dist/md5';
export default /*#__PURE__*/_defineComponent({
  __name: 'editPassword',
  props: {
    userInfo: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['success'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const ruleFormPasswordRef = ref();
    const getVerCode = async () => {
      const params = {
        Phone: props.userInfo.Phone,
        Type: 4
      };
      return await apiSendSms(params);
    };
    const {
      codeState,
      getVerCodeFn
    } = useGetVerCode(getVerCode);
    const editPasswordForm = ref({
      code: '',
      password: '',
      confPassword: ''
    });
    const editPasswordRules = reactive({
      code: {
        required: true,
        message: '请输入验证码',
        trigger: 'blur'
      },
      password: {
        required: true,
        message: '请输入密码',
        trigger: 'blur'
      },
      confPassword: {
        required: true,
        message: '请输入密码',
        trigger: 'blur'
      }
    });
    const handleOk = formEl => {
      if (!formEl) return;
      formEl.validate(valid => {
        if (valid) {
          const data = {
            phone_code: editPasswordForm.value.code,
            new_pwd: Md5.hashStr(editPasswordForm.value.confPassword).toString()
          };
          apiSetPwd(data).then(res => {
            if (res.code === 0) {
              emits('success');
              ruleFormPasswordRef.value.resetFields();
            }
          });
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_el_button = __unplugin_components_0;
      const _component_el_input = __unplugin_components_1;
      const _component_el_form_item = __unplugin_components_2;
      const _component_el_form = __unplugin_components_3;
      const _component_u_card_pane = _resolveComponent("u-card-pane");
      return _openBlock(), _createBlock(_component_u_card_pane, {
        name: "editPassword"
      }, {
        default: _withCtx(() => [(_openBlock(), _createBlock(_Teleport, {
          to: "#editPassword"
        }, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = $event => handleOk(_unref(ruleFormPasswordRef)))
        }, {
          default: _withCtx(() => [_createTextVNode("确定")]),
          _: 1
        })])), _createVNode(_component_el_form, {
          ref_key: "ruleFormPasswordRef",
          ref: ruleFormPasswordRef,
          model: _unref(editPasswordForm),
          rules: _unref(editPasswordRules),
          "label-width": "120px",
          "status-icon": ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "手机号",
            prop: "Phone"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_input, {
              value: __props.userInfo.Phone,
              disabled: "",
              style: {
                "width": "300px"
              }
            }, null, 8, ["value"]), _createVNode(_component_el_button, {
              class: "marginL20",
              type: "primary",
              loading: _unref(codeState).isLoading,
              disabled: !_unref(codeState).isClick,
              onClick: _unref(getVerCodeFn)
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(codeState).text), 1)]),
              _: 1
            }, 8, ["loading", "disabled", "onClick"])])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "验证码",
            prop: "code"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(editPasswordForm).code,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(editPasswordForm).code = $event),
              style: {
                "width": "300px"
              },
              maxlength: "100"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "新密码",
            prop: "password"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(editPasswordForm).password,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(editPasswordForm).password = $event),
              style: {
                "width": "300px"
              },
              maxlength: "100"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "确认密码",
            prop: "confPassword"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(editPasswordForm).confPassword,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(editPasswordForm).confPassword = $event),
              style: {
                "width": "300px"
              },
              maxlength: "100"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      });
    };
  }
});